export default {
  init() {

    $('.woocommerce-product-gallery__wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });

  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js